import PropTypes from 'prop-types'
import { isNil } from 'ramda'
import enumCollections from 'constants/enumCollections'

class ContactsV2 {
  constructor(init) {
    // console.log('> ContactsV2 constructor -', init)
    if (isNil(init)) return undefined
    this._address = init.address
    this._address_line_1 = init.address_line_1
    this._address_line_2 = init.address_line_2
    this._city = init.city
    this._confidence = init.confidence
    this._name = init.name
    this._phones = init.phones
    this._faxes = init.faxes
    this._rightway_primary = init.rightway_primary
    this._rightway_primary_phone = init.rightway_primary_phone
    this._state = init.state
    this._street = init.street
    this._uuid = init.uuid
    this._zip = init.zip
  }

  static shape = {
    address: PropTypes.string,
    address_line_1: PropTypes.string,
    address_line_2: PropTypes.string,
    city: PropTypes.string,
    confidence: PropTypes.number,
    name: PropTypes.string,
    phones: PropTypes.array,
    faxes: PropTypes.array,
    rightway_primary: PropTypes.bool,
    rightway_primary_phone: PropTypes.string,
    state: PropTypes.string,
    street: PropTypes.string,
    uuid: PropTypes.string,
    zip: PropTypes.string
  }

  static getStateName(rawType) {
    return (
      enumCollections?.US_STATE_NAME?.enumValues?.find(i => i.name === rawType)
        ?.description || rawType
    )
  }

  get address() {
    return this._address || ''
  }

  get address_line_1() {
    return this._address_line_1 || ''
  }

  get address_line_2() {
    return this._address_line_2 || ''
  }

  get city() {
    return this._city || ''
  }

  get confidence() {
    return this._confidence || null
  }

  get name() {
    return this._name || ''
  }

  get phones() {
    return this._phones || []
  }

  get faxes() {
    return this._faxes || []
  }

  get rightway_primary() {
    return this._rightway_primary || false
  }

  get rightway_primary_phone() {
    return this._rightway_primary_phone || ''
  }

  get state() {
    return this._state || ''
  }

  get street() {
    return this._street || ''
  }

  get uuid() {
    return this._uuid || ''
  }

  get zip() {
    return this._zip || ''
  }
}

export default ContactsV2
